import script from "./FormTipBox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTipBox.vue?vue&type=script&setup=true&lang=js"

import "./FormTipBox.vue?vue&type=style&index=0&id=781c649f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781c649f"]])

export default __exports__